import iso3166 from "../data/iso3166-alpha3-to-alpha2.json";

const FLAG_CDN_BASE = "https://flagcdn.com";

export function flagImageUrlFromAlpha2(alpha2) {
  if (!alpha2 || alpha2.length !== 2) return null;
  const a = alpha2.toLowerCase();
  return `${FLAG_CDN_BASE}/w40/${a}.png`;
}

export function flagEmojiFromAlpha2(alpha2) {
  if (!alpha2 || alpha2.length !== 2) return "\u2003";
  const A = alpha2.toUpperCase();
  if (A === "AQ" || A === "BV" || A === "HM" || A === "TF") return "\u2003";
  try {
    return String.fromCodePoint(
      ...[...A].map((c) => 127397 + c.charCodeAt(0))
    );
  } catch {
    return "\u2003";
  }
}

export function countryNameFromAlpha3(alpha3, locale = "en") {
  const a3 = String(alpha3 || "").toUpperCase();
  if (!a3) return "—";
  const a2 = iso3166[a3];
  if (!a2) return a3;
  try {
    return new Intl.DisplayNames([locale], { type: "region" }).of(a2);
  } catch {
    return a2;
  }
}

export function flagEmojiFromAlpha3(alpha3) {
  const a2 = iso3166[String(alpha3 || "").toUpperCase()];
  return flagEmojiFromAlpha2(a2);
}

export function flagImageUrlFromAlpha3(alpha3) {
  const a2 = iso3166[String(alpha3 || "").toUpperCase()];
  return flagImageUrlFromAlpha2(a2);
}

function formatPct(share) {
  const x = Number(share);
  if (Number.isNaN(x) || x <= 0) return "0%";
  if (x >= 1) return `${Math.round(x)}%`;
  return "<1%";
}

export function buildTopCountryRows(countries, locale, limit = 5) {
  if (!countries?.length) return [];
  const sorted = [...countries].sort(
    (a, b) => (Number(b.clicks) || 0) - (Number(a.clicks) || 0)
  );
  const top = sorted.slice(0, limit);
  const maxClicks = Math.max(...top.map((c) => Number(c.clicks) || 0), 1);
  return top.map((c) => {
    const code = String(c.code || "").toUpperCase();
    const clicks = Number(c.clicks) || 0;
    const share = Number(c.share);
    const a2 = iso3166[code];
    return {
      code,
      name: countryNameFromAlpha3(code, locale),
      flagSrc: flagImageUrlFromAlpha2(a2),
      pctLabel: formatPct(share),
      barPct: Math.round((clicks / maxClicks) * 1000) / 10,
    };
  });
}
